import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-isomaster-red-loading',
  templateUrl: './isomaster-red-loading.component.html',
  styleUrls: ['./isomaster-red-loading.component.scss'],
})
export class IsomasterRedLoadingComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
